module.exports = __webpack_public_path__ + "img/qr_3.df130ba5.png";